module.exports = __webpack_public_path__ + "media/images/true-link-card-b1048b81694e6b2a221aecc38bc69faa.png";